import React from 'react';
import { Banner, Card } from '@braze/web-sdk';
import nonCriticalException from '../../../modules/exceptionLogger';
import { BrazeBannerCard } from './cards/BrazeBannerCard';
import type { BrazeCard, BrazeCardEvent } from './types';

export type BrazeContentCardProps = {
  card: BrazeCard;
  width?: number;
  height?: number;
  onPress?: (e: BrazeCardEvent) => void;
};

export const BrazeContentCard: React.FCWithChildren<BrazeContentCardProps> = ({
  card,
  width,
  height,
  onPress,
}) => {
  const handleClick = () => {
    onPress?.({ card });
  };

  if (card instanceof Banner) {
    return (
      <BrazeBannerCard
        card={card}
        width={width}
        height={height}
        onClick={handleClick}
      />
    );
  }

  if (card instanceof Card) {
    nonCriticalException(`Attempted to render an unsupported Braze content card type: ${card?.extras?.type}}.`);
  }

  return null;
};
